var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBnbDark = function SvgBnbDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.93 8.601 5.634-3.268 5.634 3.268-2.071 1.207-3.563-2.06-3.563 2.06-2.071-1.207Zm11.268 4.121-2.071-1.207-3.563 2.06-3.563-2.06-2.071 1.207v2.414l3.563 2.06v4.122l2.071 1.207 2.072-1.207v-4.121l3.563-2.06v-2.415Zm0 6.535v-2.414l-2.071 1.207v2.415l2.072-1.208Zm1.471.854-3.563 2.06v2.415l5.635-3.268v-6.535l-2.072 1.207v4.12Zm-2.071-9.45 2.071 1.208v2.414l2.072-1.207v-2.414l-2.072-1.208-2.071 1.208Zm-7.105 12.384v2.415l2.071 1.207 2.072-1.207v-2.415l-2.072 1.207-2.071-1.207Zm-3.563-3.788L13 20.464V18.05l-2.071-1.207v2.414Zm3.563-8.595 2.071 1.207 2.072-1.207-2.072-1.208-2.071 1.208Zm-5.034 1.207 2.072-1.207-2.072-1.208-2.071 1.208v2.414l2.071 1.207V11.87Zm0 4.12-2.071-1.206v6.535l5.634 3.267v-2.414l-3.563-2.06V15.99Z",
    fill: "#2C2C2E"
  })));
};
export default SvgBnbDark;